import { Stack, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import infoIcon from "src/assets/Icons&UI/Info.svg?url";
import { useMemo } from "react";

const GoItemWithInfoToolTip = ({
  value,
  condition = false,
  title = "",
  translationProps = {}
}: {
  value: string | number;
  condition?: boolean;
  title?: string;
  translationProps?: object;
}) => {
  const { t } = useTranslation();

  const translatedTitle = useMemo(() => {
    if (!title) return "";
    if (!condition) return "";
    return t(title, translationProps);
  }, [condition, title, translationProps, t]);

  return (
    <Stack direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
      <Typography variant="subtitle2" fontWeight={"normal"} color="grey.900">
        {value || "-"}
      </Typography>
      {condition && (
        <Tooltip title={translatedTitle}>
          <img
            src={infoIcon}
            alt="infoIcon"
            draggable="false"
            style={{ cursor: "pointer" }}
          />
        </Tooltip>
      )}
    </Stack>
  );
};

export default GoItemWithInfoToolTip;
